// Lib
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Flex, Text } from 'rebass';

// Components
import EmptyRecruiter from './EmptyRecruiter';

const Animate = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const Content = styled(Flex)`
  animation: ${Animate} 0.5s ease-in-out 0s forwards;
`;

interface EmptyCandidatesProps {
  children: any;
  visible: boolean;
}

const EmptyCandidates: React.FC<EmptyCandidatesProps> = (props): JSX.Element | null => {
  const { children, visible } = props;

  return !visible ? null : (
    <Content css="margin-top: 60px;" justifyContent="center">
      <Text fontSize="42px" fontWeight="bold" textAlign="center">
        {children}
      </Text>
    </Content>
  );
};

export { EmptyRecruiter };
export default EmptyCandidates;
